export { ChipComponent } from './chip.component';
